import { selectUserConfiguration } from '@/features/domain/user'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { form } from '../../../formState'

export function useConnectedToStatusFields() {
  const formApi = form.useFormApi()
  const { userType } = useSelector(selectUserConfiguration)
  const is360 = userType === 'rm360' || userType === 'rm360Legacy'
  const status = form.useFormField('status')
  const statusValue = status.field.value

  useEffect(() => {
    if (statusValue === 'ADVANCED' && is360) {
      //TODO: Re-enable that field once it will be available
      // formApi.setFieldVisibleState('forbidDriverCallsToCompletedOrderSteps', true)
      // formApi.setFieldVisibleState('forbidDriverCallsToIncompleteOrderSteps', true)

      formApi.setFieldVisibleState('callbackConfigStatus', true)
      formApi.setFieldVisibleState('backOfficePhone', true)
    } else {
      //TODO: Re-enable that field once it will be available
      // formApi.setFieldVisibleState('forbidDriverCallsToCompletedOrderSteps', false)
      // formApi.setFieldVisibleState('forbidDriverCallsToIncompleteOrderSteps', false)

      formApi.setFieldVisibleState('callbackConfigStatus', false)
      formApi.setFieldVisibleState('backOfficePhone', false)
      formApi.clearError('backOfficePhone')
    }
  }, [statusValue, formApi, is360])
}
